$(() => {
  // There's a button near the bottom of the page called `sign up` that when
  // click should scroll back to the top
  const navBarHash = '#nav-bar';
  $(`a[href="${navBarHash}"]`).on('click', (e) => {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $(navBarHash).offset().top,
    }, 500, () => {
      $('#email').focus();
    });
  });
});
